<template>
  <div class="m-activity-winning-record">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="120" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getWinningRecord, api_getExportCouponCenterRecord } from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import Table from "@/components/Table/index";
import { downFile } from "@/utils";
import Search from "@/components/Search/index";

export default {
  name: "marketActivityListIndex",
  components: {
    AuthButton,
    Table,
    Search
  },
  data() {
    return {
      form: {},
      exportLoading: false,
      tableKey: false,
      renderData: [
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone"
        },
        {
          label: "领取时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp',
        },
      ],
      tableThData: [
        { prop: "name", label: "券名称", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "created", label: "领取时间", minWidth: "180", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
    };
  },
  created() {
    this.handleTableThData()
    this.getList()
  },
  methods: {
    handleTableThData() {
      if (this.$route.query.type == 'CouponCenter') {
        this.tableThData = [
          { prop: "name", label: "券名称", minWidth: "180", },
          { prop: "phone", label: "会员手机号", minWidth: "180", },
          { prop: "created", label: "领取时间", minWidth: "180", },
          { prop: "source", label: "来源", minWidth: "120", },
        ]
      }
    },

    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.form.time && this.form.time[0] && (params.startTime = this.form.time[0])
      this.form.time && this.form.time[1] && (params.endTime = this.form.time[1])
      delete params.time
      try {
        const data = await api_getWinningRecord(params)
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onSearch(form) {
      this.form = form
      this.offset = 0
      this.getList()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
      }
      this.form.time && this.form.time[0] && (params.startTime = this.form.time[0])
      this.form.time && this.form.time[1] && (params.endTime = this.form.time[1])
      delete params.time
      let res = await api_getExportCouponCenterRecord(params)
      downFile(res)
      this.exportLoading = false
    },

    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    }

  },
};
</script>

<style lang="scss" scoped>
.m-activity-winning-record {
  padding: 0 20px;
  box-sizing: border-box;

  .search {
    margin-top: 20px;
  }
  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .table-box {
    margin-top: 0px !important;
  }
  .el-button {
    min-width: 80px !important;
  }
}
</style>
